import React, { createContext, useContext, useState, useCallback } from 'react';

interface UISettings {
  showHiddenContent: boolean;
  showFloatingChat: boolean;
  showQuickCommand: boolean;
}

interface UISettingsContextValue {
  settings: UISettings;
  toggleShowHiddenContent: () => void;
  toggleShowFloatingChat: () => void;
  toggleShowQuickCommand: () => void;
}

const UISettingsContext = createContext<UISettingsContextValue | undefined>(undefined);

export const UISettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [settings, setSettings] = useState<UISettings>({
    showHiddenContent: false,
    showFloatingChat: true,
    showQuickCommand: true,
  });

  const toggleShowHiddenContent = useCallback(() => {
    setSettings(prev => ({ ...prev, showHiddenContent: !prev.showHiddenContent }));
  }, []);

  const toggleShowFloatingChat = useCallback(() => {
    setSettings(prev => ({ ...prev, showFloatingChat: !prev.showFloatingChat }));
  }, []);

  const toggleShowQuickCommand = useCallback(() => {
    setSettings(prev => ({ ...prev, showQuickCommand: !prev.showQuickCommand }));
  }, []);

  return (
    <UISettingsContext.Provider value={{ settings, toggleShowHiddenContent, toggleShowFloatingChat, toggleShowQuickCommand }}>
      {children}
    </UISettingsContext.Provider>
  );
};

export const useUISettings = (): UISettingsContextValue => {
  const ctx = useContext(UISettingsContext);
  if (!ctx) {
    throw new Error('useUISettings must be used within a UISettingsProvider');
  }
  return ctx;
};

